export function withDefinedFields(entries) {
  const body = {};
  for (const [key, value] of entries) {
    if (value !== undefined) body[key] = value;
  }
  return body;
}

export function toFormData(entries) {
  const formData = new FormData();
  for (const [key, value] of entries) {
    if (value === undefined || value === null) continue;
    if (Array.isArray(value)) {
      value.forEach((item) => formData.append(key, item));
    } else {
      formData.append(key, value);
    }
  }
  return formData;
}
